<template>
  <div class="authenticationTabs" style="height:100%">
    <h4 class="tabBox">
      <button :class="activeName==='authentication' && 'active'" @click="activeName='authentication'">个人认证</button>
      <button :class="activeName==='companyAuthentication' && 'active'"
        @click="activeName='companyAuthentication'">企业认证</button>
    </h4>
    <authentication v-if="activeName==='authentication'"> </authentication>
    <companyAuthentication v-if="activeName==='companyAuthentication'"> </companyAuthentication>
    <!-- <el-tabs v-model="activeName">
      <el-tab-pane label="个人认证" name="authentication">
        <authentication v-if="activeName==='authentication'"> </authentication>
      </el-tab-pane>
      <el-tab-pane label="企业认证" name="companyAuthentication" style="height:100%">
        <companyAuthentication v-if="activeName==='companyAuthentication'"> </companyAuthentication>
      </el-tab-pane>
    </el-tabs> -->
  </div>
</template>

<script>

import authentication from "./authentication.vue";
import companyAuthentication from "./companyAuthentication.vue";
export default {
  name: "authenticationTabs",
  inject: ['reload'],
  components: {
    authentication,
    companyAuthentication
  },
  data () {
    return {
      activeName: "authentication",

    };
  },
  computed: {

  },
  created () {

  },
  updated () {

  },
  methods: {
    handleClick () {

    }
  },
};
</script>
<style lang="less" scoped>
.authenticationTabs {
  .tabBox {
    text-align: left;
    padding-top: 8px;
    margin-bottom: 30px;
    button {
      width: 100px;
      height: 32px;
      border-radius: 4px;
    }
    button {
      background: rgba(239, 245, 254, 1);
      color: #256dff;
      border: 1px solid rgba(37, 109, 255, 1);
      margin-right: 20px;
    }
    .active {
      color: #ffffff;
      background: rgba(37, 109, 255, 1);
      border: 1px solid rgba(37, 109, 255, 1);
    }
  }
  /deep/.el-tabs .el-tabs__content {
    height: calc(100% - 55px);
  }
}
</style>